/*
 * types/services/dr2am.locales.proto
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: version not set
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.21
 *
 * Do not edit the class manually.
 *
 */

import {ApiClient} from '../ApiClient';
import {PbResponseState} from './PbResponseState';

/**
 * The ServiceAddLocaleResponse model module.
 * @module model/ServiceAddLocaleResponse
 * @version version not set
 */
export class ServiceAddLocaleResponse {
  /**
   * Constructs a new <code>ServiceAddLocaleResponse</code>.
   * @alias module:model/ServiceAddLocaleResponse
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ServiceAddLocaleResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ServiceAddLocaleResponse} obj Optional instance to populate.
   * @return {module:model/ServiceAddLocaleResponse} The populated <code>ServiceAddLocaleResponse</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ServiceAddLocaleResponse();
      if (data.hasOwnProperty('state'))
        obj.state = PbResponseState.constructFromObject(data['state']);
    }
    return obj;
  }
}

/**
 * @member {module:model/PbResponseState} state
 */
ServiceAddLocaleResponse.prototype.state = undefined;


